"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var webmaf_bridge_1 = require("./webmaf-bridge");
var webmaf_player_1 = require("./webmaf-player");
var webmaf_storage_1 = require("./webmaf-storage");
var webmaf_info_1 = require("./webmaf-info");
var webmaf_input_1 = require("./webmaf-input");
var webmaf_lifecycle_1 = require("./webmaf-lifecycle");
var webmaf_network_status_1 = require("./webmaf-network-status");
var webmaf_capabilities_1 = require("./webmaf-capabilities");
var webmaf_deeplink_1 = require("./webmaf-deeplink");
var WebmafDeviceFactory = (function () {
    function WebmafDeviceFactory(context) {
        if (context === void 0) { context = window; }
        this.context = context;
    }
    WebmafDeviceFactory.prototype.identifiers = function () {
        return [client_lib_js_player_addons_common_player_1.DeviceType.PS4, client_lib_js_player_addons_common_player_1.DeviceType.PS3, client_lib_js_player_addons_common_player_1.DeviceType.WebMaf];
    };
    WebmafDeviceFactory.prototype.getInstance = function () {
        return this.device;
    };
    WebmafDeviceFactory.prototype.initialise = function () {
        var _this = this;
        var bridge = new webmaf_bridge_1.WebMafBridge(this.context);
        var player = new webmaf_player_1.WebMafPlayer(this.context, bridge);
        var storage = new webmaf_storage_1.WebMafStorage(bridge);
        var deviceInfo = new webmaf_info_1.WebMafInfo(bridge);
        var input = new webmaf_input_1.WebMafInput(this.context);
        var lifecycle = new webmaf_lifecycle_1.WebMafLifecycle(bridge);
        var networkStatus = new webmaf_network_status_1.WebMafNetworkStatus(bridge);
        var deeplink = new webmaf_deeplink_1.WebmafDeeplink(bridge);
        var capabilities = new webmaf_capabilities_1.WebMafCapabilities();
        return Promise.all([player.initialise(), deeplink.initialise(), storage.initialise(), deviceInfo.initialise()]).then(function () {
            _this.device = {
                player: player,
                storage: storage,
                input: input,
                deeplink: deeplink,
                deviceInfo: deviceInfo,
                lifecycle: lifecycle,
                networkStatus: networkStatus,
                capabilities: capabilities,
            };
        });
    };
    return WebmafDeviceFactory;
}());
exports.WebmafDeviceFactory = WebmafDeviceFactory;
